import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';

import media from 'src/styles/media';

export default class VideoPlayer extends Component {
  state = {
    showVideo: false,
  };

  static propTypes = {
    url: PropTypes.string,
    background: PropTypes.string,
    aspectRatio: PropTypes.number,
  };

  handleClickPlay = () => {};

  render() {
    return (
      <Root aspectRatio={56} id="HeroVideo">
        <VideoContainer>
          {/* <ReactPlayer
            url="https://media.bamdigital.com/gryphon/shared/vmo-promo-4k-trimmed-1080p.mp4"
            playing
            width="100%"
            height="100%"
            loop
            muted
            playsinline
          /> */}
          <video
            src="https://media.bamdigital.com/gryphon/shared/vmo-promo-4k-trimmed-1080p.mp4"
            muted
            loop
            autoPlay
            playsInline
          />
        </VideoContainer>
      </Root>
    );
  }
}

const Root = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  video {
    object-fit: cover;
    object-position: 50% 50%;
  }
`;

const VideoContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  video {
    width: 100%;
    height: 100%;
  }
  @media (max-width: ${media.md}) {
    /* display: none; */
  }
`;
